import axios from "@/plugins/axios";

let url = (data = {}) => "/api/v1/company/recruitments/${_recruitment}/kanban".interpolate(data);

export default {
    get(data) {
        return axios.get(url(data)).then((result) => result.data);
    },
    put(data) {
        return axios.put(url(data), data).then((result) => result.data);
    },
};
